import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "modal-footer" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "form-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordStrengthHint = _resolveComponent("PasswordStrengthHint")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal-container modal-container-change-password", { hidden: !_ctx.display }]),
    tabindex: "-1",
    role: "dialog",
    "aria-hidden": !_ctx.display,
    onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.escapeToClose && _ctx.escapeToClose(...args)))
  }, [
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
      class: "modal-dialog modal-md",
      role: "document",
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.stopPropagationEvent && _ctx.stopPropagationEvent(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Replace wallet")), 1),
        _createElementVNode("button", {
          type: "button",
          class: "modal-close-btn",
          title: _ctx.$t('Close'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, _hoisted_6, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("Warning: If you replace your wallet, your old wallet will be deleted. Make sure to backup its private key before doing this.")), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("Wallet password")) + ":", 1),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            autocomplete: "new-password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createWalletPassword) = $event)),
            disabled: _ctx.busy,
            maxlength: "255",
            class: "form-control form-control-full-width auto-focus"
          }, null, 8, _hoisted_10), [
            [_vModelText, _ctx.createWalletPassword]
          ]),
          _createVNode(_component_PasswordStrengthHint, { val: _ctx.createWalletPassword }, null, 8, ["val"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("Repeat wallet password")) + ":", 1),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            autocomplete: "new-password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createWalletPassword2) = $event)),
            disabled: _ctx.busy,
            maxlength: "255",
            class: "form-control form-control-full-width"
          }, null, 8, _hoisted_12), [
            [_vModelText, _ctx.createWalletPassword2]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("Private key (Hexadecimal. If you leave it blank, it will generate a random one)")) + ":", 1),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control form-control-full-width",
            rows: "3",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createWalletPrivateKey) = $event))
          }, null, 512), [
            [_vModelText, _ctx.createWalletPrivateKey]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t("Confirm this action?")) + ":", 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_ToggleSwitch, {
            val: _ctx.confirmation,
            "onUpdate:val": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmation) = $event))
          }, null, 8, ["val"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.busy || !_ctx.confirmation,
            class: "btn btn-danger"
          }, _toDisplayString(_ctx.$t("Replace wallet")), 9, _hoisted_18)
        ]),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.error), 1)
      ])
    ], 32)
  ], 42, _hoisted_1))
}